import React from 'react';
import styles from './styles.module.scss';
// import AppImage from '../AppImage';
import { AdminContext } from '../../context/AdminContext';
import { useContext } from 'react';

const HelpBox = ({
  openInfoBox,
  setOpenInfoBox,
  children,
  text = '',
  width = 20,

  textStyle,
  extraStyle,
}) => {
  const { themeColor } = useContext(AdminContext);

  return (
    <div className={`${styles.container}  `}>
      <img
        src={'/imgs/videoUpload/help.svg'}
        alt='help'
        width={width}
        height={width}
        className={`relative ${extraStyle}`}
        onClick={() => setOpenInfoBox(!openInfoBox)}
        text={text}
        textStyle={textStyle}
        className={`flex flex-row-reverse justify-start items-center w-auto cursor-pointer`}
      />

      {openInfoBox && (
        <div
          className={`${styles.absoluteBox} ${
            themeColor != 'white' ? 'dark border' : 'light'
          }`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default HelpBox;
